import { z } from "zod";

export const aspectStatsSchema = z
  .object({
    category: z.string(),
    percentageCoverage: z.number(),
  })
  .array();
